import React from 'react';
import { Users as UsersIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

/**
 * Compact popover showing the list of learners attached to a quote/invoice.
 * Wrapped in a stop-propagation handler so opening it doesn't trigger the
 * row click (which navigates to the detail sheet).
 */
export default function QuoteLearnersPopover({ id, learnerIds = [], learnerNames = [], testIdPrefix = 'devis' }) {
  if (!Array.isArray(learnerIds) || learnerIds.length === 0) return null;
  const items = (learnerNames && learnerNames.length === learnerIds.length
    ? learnerNames.map((n, i) => ({ id: learnerIds[i], name: n }))
    : learnerIds.map((lid) => ({ id: lid, name: lid }))
  );
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testIdPrefix}-learner-count-${id}`}
          onClick={(e) => e.stopPropagation()}
          title={`${learnerIds.length} apprenant${learnerIds.length > 1 ? 's' : ''} prévu${learnerIds.length > 1 ? 's' : ''} au devis`}
          className="inline-flex items-center gap-0.5 h-5 px-1.5 rounded-md bg-[#EEF2FF] text-[#4F46E5] text-[10.5px] font-bold hover:bg-[#EDE8FF]"
        >
          <UsersIcon className="w-3 h-3" />
          {learnerIds.length}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        onClick={(e) => e.stopPropagation()}
        data-testid={`${testIdPrefix}-learner-popover-${id}`}
        className="w-[280px] p-2"
      >
        <div className="text-[11px] font-semibold uppercase tracking-wider text-[#8E8FA5] px-2 pt-1 pb-1.5">
          Apprenants prévus ({learnerIds.length})
        </div>
        <div className="space-y-0.5 max-h-[280px] overflow-y-auto">
          {items.map((l) => (
            <div key={l.id} className="px-2 py-1.5 rounded-md hover:bg-[#EEF2FF] flex items-center gap-2 text-[12.5px] text-[#1A1B2E]">
              <span className="w-6 h-6 rounded-full brand-gradient text-white text-[9px] font-semibold flex items-center justify-center shrink-0">
                {(l.name || '').split(' ').map((p) => p[0]).slice(0, 2).join('').toUpperCase() || '?'}
              </span>
              <span className="truncate">{l.name}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
